import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_ENDPOINT, USER_API_ENDPOINT } from '../config';
import { VolunteerCategory, VolunteerFilter, VolunteerRoleType } from '../models/volunteer.model';

@Injectable({
  providedIn: 'root'
})
export class VolunteerService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getVolunteerCategories(): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/Volunteer/category/all').pipe(
      map(res => res)
    )
  }

  getVolunteerCategoryById(id: string): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/Volunteer/category/' + id).pipe(
      map(res => res)
    );
  }

  deleteVolunteerCategory(id: string): Observable<any> {
    return this.httpClient.delete(USER_API_ENDPOINT + '/Volunteer/category/' + id).pipe(
      map(res => res)
    );
  }

  createVolunteerCategory(VolunteerCategory: VolunteerCategory): Observable<any> {
    return this.httpClient.post(USER_API_ENDPOINT + '/Volunteer/category', VolunteerCategory).pipe(
      map(res => res)
    )
  }

  updateVolunteerCategory(VolunteerCategory: VolunteerCategory): Observable<any> {
    return this.httpClient.put(USER_API_ENDPOINT + '/Volunteer/category/' + VolunteerCategory.id, VolunteerCategory).pipe(
      map(res => res)
    )
  }

  getVolunteerTypes(id: string): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/Volunteer/role-type/' + id + '/all').pipe(
      map(res => res)
    )
  }

  getAllVolunteerTypes(): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/Volunteer/role-type/all').pipe(
      map(res => res)
    )
  }

  getVolunteerRoleTypeById(id: string): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/Volunteer/role-type/' + id).pipe(
      map(res => res)
    );
  }

  createVolunteerRoleType(volunteerRoleType: VolunteerRoleType): Observable<any> {
    return this.httpClient.post(USER_API_ENDPOINT + '/Volunteer/role-type', volunteerRoleType).pipe(
      map(res => res)
    )
  }

  updateVolunteerRoleType(volunteerRoleType: VolunteerRoleType): Observable<any> {
    return this.httpClient.put(USER_API_ENDPOINT + '/Volunteer/role-type/' + volunteerRoleType.id, volunteerRoleType).pipe(
      map(res => res)
    )
  }

  deleteVolunteerRoleType(id: string): Observable<any> {
    return this.httpClient.delete(USER_API_ENDPOINT + '/Volunteer/role-type/' + id).pipe(
      map(res => res)
    );
  }

  getVolunteers(): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/volunteer/all').pipe(
      map(res => res)
    )
  }

  getVolunteerProfile(id: string): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/Volunteer/' + id + '/profile').pipe(
      map(res => res)
    );
  }

  exportExcel(): Observable<any> {
    return this.httpClient.post(USER_API_ENDPOINT + '/Volunteer/excel-list', null).pipe(
      map(res => res)
    )
  }

  filterVolunteers(filters: VolunteerFilter): Observable<any> {
    return this.httpClient.post(USER_API_ENDPOINT + '/volunteer/filter', filters).pipe(
      map(res => res)
    )
  }

  filterExcelVolunteers(filters: VolunteerFilter): Observable<any> {
    return this.httpClient.post(USER_API_ENDPOINT + '/volunteer/filter-excel', filters).pipe(
      map(res => res)
    )
  }
}